module.exports = __webpack_public_path__ + "img/go-back-icon.2af29777.svg";